/**
 * Returns the navigation menu items for the header tab bar,
 * filtered by the current user's role.
 *
 * @param {string} role - The authenticated user's role
 * @returns {Array<{ name: string, path: string }>}
 */
const getMenuItems = (role) => {
    if (role === 'candidate') {
        return [];
    }

    const baseItems = [
        { name: 'Events', path: '/dashboard' },
        { name: 'Users', path: '/candidates' },
    ];

    if (role === 'admin') {
        return [...baseItems, { name: 'Categories', path: '/categories' }];
    }

    return baseItems;
};

export const getActiveMenuPath = (pathname) => {
    if (pathname.startsWith('/categories')) return '/categories';
    if (pathname.startsWith('/candidates') || pathname.startsWith('/user')) return '/candidates';
    if (
        pathname.startsWith('/dashboard') ||
        pathname.startsWith('/event') ||
        pathname.startsWith('/report') ||
        pathname.startsWith('/consolidated') ||
        pathname.startsWith('/lesson') ||
        pathname.startsWith('/quiz')
    ) {
        return '/dashboard';
    }

    return pathname;
};

export const shouldShowBackButton = (role, pathname) => {
    if (!role || role === 'candidate') {
        return false;
    }

    const menuItems = getMenuItems(role);

    return !menuItems.some((item) => item.path === pathname);
};

export default getMenuItems;
